import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as moment from 'moment/moment.js';
import { getLang } from './shared/tools';
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';
import 'moment/locale/en-gb';
import 'moment/locale/fr';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: { translation: enTranslation },
    fr: { translation: frTranslation },
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

// Custom detector
let wpmlCurrentLanguage = getLang();
i18n.changeLanguage(wpmlCurrentLanguage);

// Setup locale for moment
moment.locale('fr');
if (wpmlCurrentLanguage !== '' && wpmlCurrentLanguage !== 'fr') {
    moment.locale(wpmlCurrentLanguage);
}

export default i18n;
